import axiosHttpRequest from "../axios";

//Credit Limit Check
async function getCreditlimitCheckDetailsService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  // 
  return serviceResponse;
}

// CREATE PROFORMA INVOICE
export async function createProformaInvoiceService(
  endpoint,
  postdata,
  configheaders
) {
  // 
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  // 
  return serviceResponse;
}

export async function createSFTOIOService(endpoint, postdata, configheaders) {
  // 
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  delete configheaders.sap_name_pw;
  // 
  return serviceResponse;
}

export async function createGPWISOService(endpoint, postdata, configheaders) {

  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function saveSapDefaultsService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getSapDefaultsService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }

  return listViewData;
}

async function saveContractAdvanceDetailsService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getContractAdvanceDetailsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }

  return listViewData;
}

export async function createSFTOSOService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  delete configheaders.sap_name_pw;
  return serviceResponse;
}

export async function createGPWISIOService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  delete configheaders.sap_name_pw;
  return serviceResponse;
}

export async function createGPWISSOService(endpoint, postdata, configheaders) {

  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  delete configheaders.sap_name_pw;
  return serviceResponse;
}
export async function updateSFTOSOService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    "",
    postdata,
    configheaders
  );

  delete configheaders.sap_name_pw;
  return serviceResponse;
}

export async function createInvoiceService(endpoint, postdata, configheaders) {

  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  delete configheaders.sap_name_pw;
  return serviceResponse;
}


export async function updateGPWISSOService(endpoint, postdata, configheaders) {
  // 
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    "",
    postdata,
    configheaders
  );

  delete configheaders.sap_name_pw;
  return serviceResponse;
}

export async function createInvoiceGPWISService(endpoint, postdata, configheaders) {

  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  delete configheaders.sap_name_pw;
  return serviceResponse;
}

export async function createRaekRebateSO(endpoint, postdata, configheaders) {

  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}
export async function createRaekRebateInvoice(endpoint, postdata, configheaders) {

  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}
async function saveMgtInvoiceData(endpoint, param, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    param,
    postdata,
    configheaders,
  );

  return serviceResponse;
}


export default {
  getCreditlimitCheckDetailsService,
  createProformaInvoiceService,
  createSFTOIOService,
  createGPWISOService,
  saveSapDefaultsService,
  getSapDefaultsService,
  saveContractAdvanceDetailsService,
  getContractAdvanceDetailsService,
  createSFTOSOService,
  updateSFTOSOService,
  createGPWISIOService,
  createGPWISSOService,
  createInvoiceService,
  updateGPWISSOService,
  createInvoiceGPWISService,
  createRaekRebateSO,
  createRaekRebateInvoice,
  saveMgtInvoiceData,
};
